import React from 'react';
import PropTypes from 'prop-types';

import {Pill} from 'views/components';
import {translate} from 'views/module';

const JobStatusView = (props) => {
  const {
    jobData,
    setIsEditing,
  } = props;

  const status = jobData.status;

  const title = translate(`career.Status.${status}.Title`);

  return (
    <Pill
      label={`● ${title}`}
      variant='warning'
      component='button'
      type='button'
      onClick={() => setIsEditing(true)}
      sx={{cursor: 'pointer'}}
    />
  );
};

JobStatusView.propTypes = {
  jobData: PropTypes.object.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(JobStatusView);
